export type TRoleType = 'Backoffice_DiaDia_Admin' | 'Backoffice_Insuma_Admin';

export const ROLE_LIST: Array<TRoleType> = ['Backoffice_DiaDia_Admin', 'Backoffice_Insuma_Admin'];

export class RoleError extends Error {}
